/**
 * Company: SPHMedia
 * Description: [myBH Layout 1 component]
 */

import FollowTrendingTopics, {
  FollowTrendingTopicsProps,
} from "@components/Blocks/FollowTrendingTopics/FollowTrendingTopics";
import { ProcessedArticleData } from "@hooks/transformer/useOSResponse";
import { useBHCustomEventAnalyticsCall } from "@hooks/useAnalyticsCall/useBHCustomEventAnalyticsCall";
import WidgetWrapper from "@routes/Home/HomePageLayout/WidgetWrapper";
import { ReactElement } from "react";

import {
  LAYOUT_ONE_DESKTOP_COLUMNS,
  LAYOUT_ONE_TABLET_COLUMNS,
} from "./helper/layout";
import { renderColumn } from "./helper/renderColumn";
import { renderSlot } from "./helper/renderSlot";

export type MyBHLayoutOneProps = {
  articles: ProcessedArticleData[];
  bhCustomEvent?: ReturnType<typeof useBHCustomEventAnalyticsCall>;
  userKeywords?: string;
} & FollowTrendingTopicsProps;
// & MyBHAlertBlockProps; Disable alert block for now.

/**
 * MyBHLayoutOne
 * Description: [Layout 1 component for myBH "For You" page]
 * @param props - The props required by the component (if any)
 * @returns The rendered React element
 */
export default function MyBHLayoutOne(props: MyBHLayoutOneProps): ReactElement {
  const { articles } = props;

  if (articles.length === 0) {
    return <div>No articles available.</div>;
  }

  return (
    <WidgetWrapper>
      {/* Desktop */}
      <div
        className="hidden lg:block max-w-[1183px]"
        data-testid="desktop-layout"
      >
        <div className="grid grid-cols-3 gap-5">
          {LAYOUT_ONE_DESKTOP_COLUMNS.map((column, i) => (
            <div key={`desktop-column-${i}`}>
              {renderColumn(column, articles, props)}
            </div>
          ))}
        </div>
      </div>

      {/* Tablet */}
      <div className="hidden md:block lg:hidden" data-testid="tablet-layout">
        <div className="grid grid-cols-2 gap-5">
          {LAYOUT_ONE_TABLET_COLUMNS.map((column, i) => (
            <div key={`tablet-column-${i}`}>
              {renderColumn(column, articles, props, "md")}
            </div>
          ))}
        </div>
      </div>

      {/* Mobile */}
      <div className="flex md:hidden" data-testid="mobile-layout">
        <div className="flex flex-col gap-7">
          <FollowTrendingTopics {...props} />
          {articles
            .slice(0, 5)
            .map((_, i) =>
              renderSlot({ index: i }, articles, "layoutOneMobile"),
            )}
          {/* Disable alert block for now.
          <MyBHAlertBlock {...props} uniqueKey="mybh-story-package" /> */}
        </div>
      </div>
    </WidgetWrapper>
  );
}
